import { render, staticRenderFns } from "./ShopIncomeVoucherRecord.vue?vue&type=template&id=3c20770b&scoped=true&"
import script from "./ShopIncomeVoucherRecord.vue?vue&type=script&lang=js&"
export * from "./ShopIncomeVoucherRecord.vue?vue&type=script&lang=js&"
import style0 from "./ShopIncomeVoucherRecord.vue?vue&type=style&index=0&id=3c20770b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c20770b",
  null
  
)

export default component.exports